<template>
    <v-app-bar color="primary" dark app>
        <!-- 插入公司Logo -->
        <v-img src="/assets/brand-logo.png" max-width="40" class="ml-8"></v-img>
        <v-toolbar-title class="ml-0" style="font-size: 24px;">{{ $t('companyName') }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn :to="`/${currentLang}`" text>{{ $t('nav.home') }}</v-btn>
        <v-btn :to="`/${currentLang}/about`" text>{{ $t('nav.about') }}</v-btn>
        <v-btn :to="`/${currentLang}/services`" text>{{ $t('nav.services') }}</v-btn>
        <v-btn :to="`/${currentLang}/contact`" text>{{ $t('nav.contact') }}</v-btn>
        <v-menu offset-y open-on-hover>
            <template v-slot:activator="{ props }">
                <v-btn icon v-bind="props" text>
                    <v-icon left>mdi-translate</v-icon>
                </v-btn>
            </template>
            <v-list>
                <v-list-item v-for="lang in languages" :key="lang.value" @click="changeLanguage(lang.value)">
                    <v-list-item-title>
                        <v-icon class="mr-1" color="blue">mdi-earth</v-icon>
                        {{ lang.text }}
                    </v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </v-app-bar>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

const router = useRouter() // 获取路由实例对象
const { locale } = useI18n()

const currentLang = computed(() => {
    return locale.value || 'zh'
})

const changeLanguage = (lang) => {
    if (lang === currentLang.value) return
    locale.value = lang
    router.push({ path: `/${lang}` })
}

const languages = ref([
    { value: 'en', text: 'English' },
    { value: 'zh', text: '简体中文' }
])

</script>